import { PaginateQuery, paginateQueryToURLParams } from 'src/api/pagination/dtos';
import { apiClient } from 'src/careflow/ph-core/api_client/api_client';
import { WorkflowInstanceDto } from 'src/crs/case/dto/case.dto';
import { convertFilterToPaginateQueryParams } from 'src/utils/gridView';

const apiBase = 'crs/episode-of-care';

export interface EpisodeOfCareResponse {
  createdBy: string;
  createdOn: string;
  updatedBy: string;
  updatedOn: string;
  eocId: string;
  eocUUID: string;
  fhirId: string;
  workflowInstanceId: number;
  workflowStatus: string;
  workflowSubstatus: string;
  workflowStageId: string;
  workflowStageName: string;
  workflowStageOrder: number;
  workflowDispositionReason: string;
  workflowDispositionNote: string;
  workflowDispositionOn: string;
  workflowDispositionAt: string;
  workflowOwnedBy: string;
  workflowScope: string;
  workflowReferenceName: string;
  indexedFhirRefUri: string;
  indexedSubjectFhirRefUri: string;
  indexedsubjectMrn: string;
  indexedsubjectFullName: string;
  indexedsubjectPhone: string;
  indexedsubjectEmail: string;
  indexedsubjectDob: Date;
  indexedStatus: string;
  internalNumber: string;
  subjectDOBFormatted: string;
  subjectAge: string;
  createdOnFormatted: string;
}
export interface PaginatedEpisodeOfCareResponse {
  data: EpisodeOfCareResponse[];
  links: {
    current: string;
  };
  meta: {
    currentPage: number;
    itemsPerPage: number;
    totalItems: number;
    totalPages: number;
  };
}

const eocApi = {
  getAll: async (
    queryParams: PaginateQuery
  ): Promise<PaginatedEpisodeOfCareResponse | undefined> => {
    const urlParams = paginateQueryToURLParams(queryParams);

    const filters = convertFilterToPaginateQueryParams(queryParams?.filter ?? {});
    const url = `${apiBase}/?${urlParams.toString()}${filters}`;

    return apiClient.get<PaginatedEpisodeOfCareResponse | undefined>(url);
  },
  getOne: async (fhirId: string): Promise<any> => apiClient.get<any>(`${apiBase}/${fhirId}`),
  getStatistics: async (id: string): Promise<any | undefined> =>
    apiClient.get<any | undefined>(`${apiBase}/statistics/${id}`),
  create: async (payload: any): Promise<any> => apiClient.post<any, any>(`${apiBase}`, payload),
};

export const EpisodeOfCareService = {
  getAll: async (
    queryParams: PaginateQuery
  ): Promise<PaginatedEpisodeOfCareResponse | undefined> => {
    const result = await eocApi.getAll(queryParams);
    if (!result) return undefined;
    return result;
  },
  getOne: async (fhirId: string): Promise<EpisodeOfCareResponse | undefined> => {
    const result = await eocApi.getOne(fhirId);
    if (!result) return undefined;
    return result;
  },
  getStatistics: async (id: string): Promise<any | undefined> => {
    const statistics = await eocApi.getStatistics(id);
    if (!statistics) return undefined;
    return statistics;
  },
  create: async (payload: any): Promise<WorkflowInstanceDto | undefined> => {
    const eoc = await eocApi.create(payload);
    if (!eoc) return undefined;
    const dto = new WorkflowInstanceDto();
    dto.fromWorkflowInstanceResponse(eoc);
    return dto;
  },
};
